(function () {
  'use strict';

  var API = 'https://hodnoceni.todly.cz/api/public';
  var VERIFIED_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark-badge" viewBox="0 0 24 24">' +
    '<path fill="currentColor" d="M18.9905 19H19M18.9905 19C18.3678 19.6175 17.2393 19.4637 16.4479 19.4637C15.4765 19.4637 15.0087 19.6537 14.3154 20.347C13.7251 20.9374 12.9337 22 12 22C11.0663 22 10.2749 20.9374 9.68457 20.347C8.99128 19.6537 8.52349 19.4637 7.55206 19.4637C6.76068 19.4637 5.63218 19.6175 5.00949 19C4.38181 18.3776 4.53628 17.2444 4.53628 16.4479C4.53628 15.4414 4.31616 14.9786 3.59938 14.2618C2.53314 13.1956 2.00002 12.6624 2 12C2.00001 11.3375 2.53312 10.8044 3.59935 9.73817C4.2392 9.09832 4.53628 8.46428 4.53628 7.55206C4.53628 6.76065 4.38249 5.63214 5 5.00944C5.62243 4.38178 6.7556 4.53626 7.55208 4.53626C8.46427 4.53626 9.09832 4.2392 9.73815 3.59937C10.8044 2.53312 11.3375 2 12 2C12.6625 2 13.1956 2.53312 14.2618 3.59937C14.9015 4.23907 15.5355 4.53626 16.4479 4.53626C17.2393 4.53626 18.3679 4.38247 18.9906 5C19.6182 5.62243 19.4637 6.75559 19.4637 7.55206C19.4637 8.55858 19.6839 9.02137 20.4006 9.73817C21.4669 10.8044 22 11.3375 22 12C22 12.6624 21.4669 13.1956 20.4006 14.2618C19.6838 14.9786 19.4637 15.4414 19.4637 16.4479C19.4637 17.2444 19.6182 18.3776 18.9905 19Z"/>' +
    '<path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12.8929L10.8 14.5L15 9.5"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function czAgo(n, one, few, many) {
    if (n === 1) return 'před ' + one;
    if (n >= 2 && n <= 4) return 'před ' + n + ' ' + few;
    return 'před ' + n + ' ' + many;
  }

  function relTime(s) {
    var d = new Date(s);
    if (isNaN(d.getTime())) return '';
    var days = Math.floor((new Date() - d) / 86400000);
    if (days < 0) days = 0;
    if (days === 0) return 'dnes';
    if (days === 1) return 'včera';
    if (days < 7) return 'před ' + days + ' dny';
    if (days < 31) return czAgo(Math.floor(days / 7), 'týdnem', 'týdny', 'týdny');
    if (days < 365) return czAgo(Math.floor(days / 30), 'měsícem', 'měsíci', 'měsíci');
    return czAgo(Math.floor(days / 365), 'rokem', 'lety', 'lety');
  }

  function initWidget(widget) {
    var id = widget.getAttribute('data-product-id');
    if (!id) return;

    var verifiedLabel = widget.getAttribute('data-verified-label') || 'Ověřený nákup';
    var verbLabel = widget.getAttribute('data-verb-label') || 'hodnotí produkt';
    var perPage = 5;
    var page = 1;
    var totalPages = 1;
    var sort = 'with_text';

    var listEl = widget.querySelector('[data-reviews-list]');
    var loadingEl = widget.querySelector('[data-reviews-loading]');
    var emptyEl = widget.querySelector('[data-reviews-empty]');
    var paginationEl = widget.querySelector('[data-reviews-pagination]');
    var prevBtn = widget.querySelector('[data-reviews-prev]');
    var nextBtn = widget.querySelector('[data-reviews-next]');
    var statusEl = widget.querySelector('[data-reviews-status]');

    function reviewHtml(review) {
      var name = esc(review.reviewer);
      var initial = name ? name.charAt(0).toUpperCase() : '?';
      var avatar = review.avatar
        ? '<img class="pdp-review__avatar-img" src="' + esc(review.avatar) + '" alt="" loading="lazy" width="46" height="46">'
        : initial;
      var stars = parseInt(review.stars, 10) || 0;
      var date = relTime(review.date);
      var comment = review.comment
        ? '<p class="pdp-review__text">' + esc(review.comment).replace(/\n/g, '<br>') + '</p>'
        : '';
      return (
        '<li class="pdp-review">' +
        '<span class="pdp-review__avatar" aria-hidden="true">' + avatar + '</span>' +
        '<div class="pdp-review__content">' +
        '<div class="pdp-review__head">' +
        '<span class="pdp-review__name">' + name + '</span>' +
        '<span class="pdp-review__verb">' + esc(verbLabel) + '</span>' +
        '<div class="rating" role="img" aria-label="' + stars + '/5">' +
        '<span aria-hidden="true" class="rating-star" style="--rating:' + stars + ';--rating-max:5;--rating-decimal:0;"></span>' +
        '</div>' +
        '</div>' +
        '<div class="pdp-review__meta">' +
        '<span class="pdp-review__verified"><span class="svg-wrapper">' + VERIFIED_SVG + '</span>' + esc(verifiedLabel) + '</span>' +
        (date ? '<span class="pdp-review__date">' + date + '</span>' : '') +
        '</div>' +
        comment +
        '</div>' +
        '</li>'
      );
    }

    function setPagination(current, total) {
      page = current;
      totalPages = total;
      if (prevBtn) prevBtn.disabled = current <= 1;
      if (nextBtn) nextBtn.disabled = current >= total;
      if (statusEl) statusEl.textContent = current + '/' + total;
      if (paginationEl) paginationEl.hidden = total <= 1;
    }

    function load(targetPage) {
      if (loadingEl) loadingEl.hidden = false;
      if (emptyEl) emptyEl.hidden = true;

      var url = API + '/reviews?product_id=' + encodeURIComponent(id) +
        '&page=' + targetPage + '&per_page=' + perPage + '&sort=' + sort;

      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (result) {
          if (loadingEl) loadingEl.hidden = true;
          if (!result || !result.success) {
            if (targetPage === 1 && emptyEl) emptyEl.hidden = false;
            return;
          }
          var reviews = result.data || [];
          var meta = result.meta || {};

          if (reviews.length > 0) {
            listEl.innerHTML = reviews.map(reviewHtml).join('');
            setPagination(meta.current_page || 1, meta.last_page || 1);
          } else {
            listEl.innerHTML = '';
            if (paginationEl) paginationEl.hidden = true;
            if (targetPage === 1 && emptyEl) emptyEl.hidden = false;
          }
        })
        .catch(function () {
          if (loadingEl) loadingEl.hidden = true;
          if (targetPage === 1 && emptyEl) emptyEl.hidden = false;
        });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (page > 1) load(page - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (page < totalPages) load(page + 1);
      });
    }

    load(1);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-reviews-widget]'), initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
